module.exports = __webpack_public_path__ + "img/powerby-nectios.46fc76c6.svg";